import jQuery from "vendor/jquery";
import $ from "vendor/jquery";
import _ from "vendor/lodash";
import Immutable from "community/immutable";
import "vendor/es6-promise";
import Module from "global/sparta-module-utility";
import spartaStyleUtility from "global/sparta-style-utility";
import Utility from "community/module-utils-utility";
import Handlebars from "vendor/handlebars";
import Templates from "global/sparta-templates-utility";
import "css!modules/home-loans/services-home-loans-module/2.2.0/css/services-home-loans-module.scss.css";

const scope = {};
class servicesHomeLoansModuleTemplates extends Templates {
  constructor() {
    super();
    scope.templates = [{ name: 'services-home-loans-module', precompiled: {"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<script type=\"text/json\" id=\"ratePayloads\">"
    + ((stack1 = (helpers.json || (depth0 && depth0.json) || helpers.helperMissing).call(depth0 != null ? depth0 : {},(depth0 != null ? depth0.ratePayloads : depth0),{"name":"json","hash":{},"data":data})) != null ? stack1 : "")
    + "</script>\n";
},"useData":true} }];
  }

  get templates() { return scope.templates; }
  get(templateName) {
    return Handlebars.template(_.find(this.templates, {
      name: templateName
    }).precompiled);
  }
};

export default new servicesHomeLoansModuleTemplates();
